import React from 'react'
import './Message.css'

export default function Message(props) {
    return (
        <div className="main__message">
            {
                props.user === 'admin' ?
                <div className="message admin">{props.message}</div> 
                :
                props.user === 'You' ?
                <div className="message You">{props.message}</div>
                : <div className="message">{props.message}</div> 
            }
            <div className="sender" style={{textTransform: 'lowercase'}}>{props.user}</div>
        </div>
    )
}
